import { render } from "./ManageYourNFT.vue?vue&type=template&id=7c140fc8&ts=true"
import script from "./ManageYourNFT.vue?vue&type=script&lang=ts"
export * from "./ManageYourNFT.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__